import FileManagerIcon from "../assets/svg/sidebar/file-manager.svg";
import DocAssistantIcon from "../assets/svg/sidebar/docplace-ai.svg";
import SettingIcon from "../assets/svg/sidebar/settings.svg";
import DocumentTypeIcon from "../assets/svg/Docplace Dashboard.svg";
import MasterScannerIcon from "../assets/svg/Document Scanner (1).svg";
import InputMethodIcon from "../assets/svg/Docplace FrameInput.svg";
import ESignatureIcon from "../assets/svg/sidebar/docplace-sign.svg";
import DPForms from "../assets/svg/sidebar/docplace-forms.svg";
import DPWorkflow from "../assets/svg/sidebar/workflows.svg";
import DPSearch from "../assets/svg/icons/search.svg";
import DPBatch from "../assets/svg/Vector from Docplace (1).svg";
import DPSecu from "../assets/svg/sidebar/security.svg";
import DPGroupUser from "../assets/svg/Group.svg";
export const sidebarItemsList = [
  /* {
              id: "document-1",
              header: {
                id: "documentHeader-1",
                title: "Documents",
                icon: Documents,
                hideList: false,
              },
              children: [
                {
                  id: "fileManager",
                  title: "File Manager",
                  icon: FileManagerIcon,
                  active: true,
                },
                {
                  id: "Search",
                  title: "Search",
                  icon: DPSearch,
                  active: false,
                },
                {
                  id: "DocAssistant",
                  title: "DocPlace AI",
                  icon: DocAssistantIcon,
                  active: true,
                },
              ],
            }, */
  {
    id: "fileManager",
    header: {
      id: "file-manager-header-1",
      title: "File Manager",
      icon: FileManagerIcon,
      hideList: true,
      active: true,
      color: "#E9F3FF",
      path: "/explorer",
    },
  },
  {
    id: "Search",
    header: {
      id: "search-header-1",
      title: "Search",
      icon: DPSearch,
      hideList: true,
      active: true,
      color: "#00C1D414",
      path: "/search",
    },
  },
  {
    id: "DocAssistant",
    header: {
      id: "docplace-DocAssistant-header-1",
      title: "DocPlace AI",
      icon: DocAssistantIcon,
      hideList: true,
      color: "#E2F9EA",
      path: "/docViewerAssistant/",
    },
  },
  {
    id: "docplace-esignature-id",
    header: {
      id: "docplace-esignature-header-1",
      title: "DocPlace Sign",
      icon: ESignatureIcon,
      hideList: true,
      color: "#F2F0FF",
      path: "/docplaceSign",
    },
  },
  {
    id: "docplace-forms-id",
    header: {
      id: "docplace-forms-header-1",
      title: "DocPlace Forms",
      icon: DPForms,
      hideList: true,
      color: "#FFF1C1",
      path: "/docplaceForms",
    },
  },
  {
    id: "requestedWF-id",
    header: {
      id: "requestedWF-idd",
      title: "DocPlace Workflows",
      icon: DPWorkflow,
      hideList: true,
      color: "#FFE8DE",
      path: "/requested-process",
    },
  },
  {
    id: "setting-id",
    header: {
      id: "settingHeader-1",
      title: "Settings",
      icon: SettingIcon,
      hideList: true,
      color: "#E9F3FF",
      path: "/documentType",
    },
    children: [
      {
        id: "documentType",
        title: "Document Type",
        icon: DocumentTypeIcon,
        active: true,
        path: "/documentType",
        color: "#3f3f46",
        activeColor: "#0076FF",
      },
      {
        id: "input-method",
        title: "Input Method",
        icon: InputMethodIcon,
        active: false,
        path: "/inputMethod",
        color: "#3f3f46",
        activeColor: "#0076FF",
      },
      {
        id: "batch-upload",
        title: "Batch Upload",
        icon: DPBatch,
        active: false,
        path: "/batch-upload",
        color: "#3f3f46",
        activeColor: "#0076FF",
      },
    ],
  },
  {
    id: "security",
    header: {
      id: "security-1",
      title: "Security",
      icon: DPSecu,
      hideList: true,
      color: "#E9F3FF",
    },
    children: [
      {
        id: "user",
        title: "Users",
        icon: DPGroupUser,
        active: true,
        path: "/user",
        color: "#3f3f46",
        activeColor: "#0076FF",
      },
      {
        id: "role",
        title: "Roles",
        icon: MasterScannerIcon,
        active: false,
        path: "/rol",
        color: "#3f3f46",
        activeColor: "#0076FF",
      },
    ],
  },
  // {
  //   id: "forms-id",
  //   header: {
  //     id: "formsHeader-1",
  //     title: "Forms",
  //     icon: FormsIcon,
  //     hideList: false,
  //   },
  //   children: [
  //     {
  //       id: "forms-inbox-id",
  //       title: "Forms Inbox",
  //       icon: FormsInboxIcon,
  //       active: true,
  //     },
  //     {
  //       id: "templates-id",
  //       title: "Templates",
  //       icon: FormsTemplateIcon,
  //       active: false,
  //     },
  //     {
  //       id: "templates-v2-id",
  //       title: "Templates V2",
  //       icon: FormsTemplateIcon,
  //       active: false,
  //     },
  //     {
  //       id: "assigned-id",
  //       title: "Assigned Forms",
  //       icon: FormsAssignedIcon,
  //       active: false,
  //     },
  //     {
  //       id: "trash-id",
  //       title: "Trash Bin",
  //       icon: FormsTrasBinIcon,
  //       active: false,
  //     },
  //   ],
  // },
];
